import Types from "./Types";

export const GetEmployeesSuccess = (payload) => ({
  type: Types.GET_EMPLOYEES_SUCCESS,
  payload,
});

export const EmployeesLoading = (payload) => ({
  type: Types.EMPLOYEES_LOADING,
  payload,
});

export const AddEmployeeSuccess = (payload) => ({
  type: Types.ADD_EMPLOYEE_SUCCESS,
  payload,
});

export const UpdateEmployeeSuccess = (payload) => ({
  type: Types.UPDATE_EMPLOYEE_SUCCESS,
  payload,
});

export const GetEmployeeDetailsSuccess = (payload) => ({
  type: Types.GET_EMPLOYEE_DETAILS_SUCCESS,
  payload,
});

export const DeleteEmployeeSuccess = (payload) => ({
  type: Types.DELETE_EMPLOYEE_SUCCESS,
  payload,
});
